module.exports = __webpack_public_path__ + "img/12.096070c6.jpg";